import { reject } from 'lodash';
import {
  ADD_COMPANIES_GROUP_FILTER_ID,
  ADD_PEOPLE_GROUP_FILTER_ID,
  CLEAR_FILTERS,
  CHANGE_COMPANY_PAGE,
  CHANGE_COMPANY_SORT,
  CHANGE_PERSON_PAGE,
  CHANGE_PERSON_SORT,
  CHANGE_RELATED_SEARCH,
  CHANGE_SEARCH_TEXT,
  CLEAR_RELATED_MODEL_FILTERS,
  TOGGLE_ROLE,
  REMOVE_COMPANIES_GROUP_FILTER_ID,
  REMOVE_PEOPLE_GROUP_FILTER_ID,
  SELECT_EXCLUDE_TAGS,
  SET_COMPANIES_GROUP_FILTER_IDS,
  SET_BACK_TO_LINK,
  SET_PEOPLE_GROUP_FILTER_IDS,
  SET_PROPERTY_IDS,
  SET_ROLES,
  SET_TAGS
} from '../actions/query';

export default function(state = {}, action) {
  switch (action.type) {
  case CHANGE_COMPANY_PAGE:
    return {
      ...state,
      companyPage: action.page
    };
  case CHANGE_COMPANY_SORT:
    return {
      ...state,
      companySort: action.sort
    };
  case CHANGE_PERSON_PAGE:
    return {
      ...state,
      personPage: action.page
    };
  case CHANGE_PERSON_SORT:
    return {
      ...state,
      personSort: action.sort
    };
  case CHANGE_RELATED_SEARCH:
    return {
      ...state,
      relatedSearchId: action.id
    };
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      searchText: action.value,
      companyPage: 1,
      personPage: 1
    };
  case CLEAR_FILTERS: {
    return {
      ...state,
      relatedSearchId: null,
      backToLink: "",
      roles: [],
      searchText: "",
      tags: [],
      tagIds: [],
      propertyIds: [],
      companyPage: 1,
      personPage: 1
    };
  }
  case CLEAR_RELATED_MODEL_FILTERS: {
    const { relatedSearchId, ...newState } = state;
    return newState;
  }

  case SET_COMPANIES_GROUP_FILTER_IDS: {
    return {
      ...state,
      companyGroupIds: action.groupIds,
      companyPage: 1,
      personPage: 1
    };
  }

  case ADD_COMPANIES_GROUP_FILTER_ID: {
    if (state.companyGroupIds.includes(action.groupId)) {
      return state;
    }

    return {
      ...state,
      companyGroupIds: [...state.companyGroupIds, action.groupId].filter(groupId => groupId !== 'ungrouped'),
      companyPage: 1,
      personPage: 1
    };
  }

  case REMOVE_COMPANIES_GROUP_FILTER_ID:
    return {
      ...state,
      companyGroupIds: state.companyGroupIds.filter(groupId => groupId !== action.groupId),
      companyPage: 1,
      personPage: 1
    };

  case SET_PEOPLE_GROUP_FILTER_IDS: {
    return {
      ...state,
      peopleGroupIds: action.groupIds,
      companyPage: 1,
      personPage: 1
    };
  }

  case ADD_PEOPLE_GROUP_FILTER_ID: {
    if (state.peopleGroupIds.includes(action.groupId)) {
      return state;
    }

    return {
      ...state,
      peopleGroupIds: [...state.peopleGroupIds, action.groupId].filter(groupId => groupId !== 'ungrouped'),
      companyPage: 1,
      personPage: 1
    };
  }

  case REMOVE_PEOPLE_GROUP_FILTER_ID:
    return {
      ...state,
      peopleGroupIds: state.peopleGroupIds.filter(groupId => groupId !== action.groupId),
      companyPage: 1,
      personPage: 1
    };

  case SELECT_EXCLUDE_TAGS: {
    return {
      ...state,
      excludeTags: !state.excludeTags
    };
  }

  case SET_BACK_TO_LINK: {
    return {
      ...state,
      backToLink: action.link
    };
  }
  case SET_PROPERTY_IDS: {
    return {
      ...state,
      propertyIds: action.propertyIds.map(Number)
    };
  }
  case SET_TAGS: {
    return {
      ...state,
      tags: [...action.tags],
      companyPage: 1,
      personPage: 1
    };
  }
  case SET_ROLES: {
    return {
      ...state,
      roles: action.roles
    };
  }
  case TOGGLE_ROLE: {
    let roles = state.roles;
    roles = reject(roles, role => role === action.role);

    if (action.checked) {
      roles.push(action.role);
    }

    return {
      ...state,
      roles: roles,
      companyPage: 1,
      personPage: 1
    };
  }
  default:
    return state;
  }
}
